import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Form, Button } from "react-bootstrap";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import SideMenu from '../../../../Components/SideDrawer';
import PageHeader from '../../../../Components/Header'
import { companyGet, employeeGet, employeePayslipReport } from "../../../../Api/Admin/AdminApi";
import { formatMonth } from "../../../../Utils/DateUtlis";
import { extractErrorMessage } from "../../../../Utils/ErrorUtlis";
import toWordsUtils from "../../../../Utils/NumberTextUtils";

const PayslipGenerate = () => {
  const [isData, setIsData] = useState(true);
  const [organizations, setOrganizations] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [loadingCompany, setLoadingComapany] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentMode, setPaymentMode] = useState(null);
  const initialData = {
    company_id: null,
    emp_id: '',
    pay_month: ''
  }
  const [formData, setFormData] = useState(initialData);
  const printRf = React.useRef(null)

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setOrganizations(companies);
          setLoadingComapany(true)
          console.log(`API Data ${JSON.stringify(organizations)}`);  // Under Production         
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchCompany();
  }, [])
  const onEmployeedetails = async (id) => {
    try {
      const employees = await employeeGet(id);
      console.log("Employee data from API", employees);

      if (employees && employees.result) {
        const emp = employees.result.map(i => ({
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          team: i.team,
          team_id: i.team_id
        }));
        setEmployeeData(emp)
        // getTeam();
        // setIsLoading(false)
      } else {
        // setIsLoading(true)
      }

    } catch (err) {
      setIsLoading(false)
      const errorMessage = extractErrorMessage(err);
      console.log('Error Fetching Employee data', errorMessage || err);
      alert(errorMessage);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (name === 'company_id') {
      onEmployeedetails(value)
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const responseData = await employeePayslipReport(formData);
      if (responseData.data) {
        const i = responseData.data
        const employeePayslip = {
          _id: i._id,
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          company: i.company,
          Design: i.Design,
          total_working_days: i.total_working_days,
          total_overtime_hours: i.total_overtime_hours,
          pay_month: formatMonth(i.pay_month),
          basic_pay: i.basic_pay,
          attendance_allowence: i.attendance_allowence,
          overtime_pay: i.overtime_pay,
          standard_gross: i.standard_gross,
          allowences: i.allowences,
          incentives: i.incentives,
          lop: i.lop,
          earned_gross: i.earned_gross,
          CPF: i.CPF,
          advances: i.advances,
          other: i.other,
          netpay: i.netpay,
          payment_mode: i.payment_mode,
          salaryWords: toWordsUtils(i.netpay)
        };
        console.log('Payment Method: ', employeePayslip.payment_mode);
        setPaymentMode(employeePayslip.payment_mode);
        setApiData(employeePayslip);
        setIsLoading(true);
        setIsData(false);
      }
    } catch (err) {
      setIsLoading(false);
      setFormData(initialData)
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Payslip Data: ', errorMessage || err);
      alert(errorMessage)
    }
  }


  const downloadPDF = async () => {
    setFormData(false);

    const element = printRf.current
    if (!element) {
      console.log('Element Not Found ');

      return
    }
    try {
      const canvas = await html2canvas(element, {
        scale: 1,
        logging: true,
        useCORS: true
      });
      const imgData = canvas.toDataURL('image/png');
      const pdfWidth = 595.28;
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      const pdf = new jsPDF({
        orientation: pdfHeight > pdfWidth ? 'portrait' : 'landscape',
        unit: 'pt',
        format: [pdfWidth, pdfHeight]
      });
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${apiData.emp_id}_payslip.pdf`);
    } catch (err) {
      console.error('Error generating PDF:', err);
    }
  }


  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader title='Employee Payroll' showButtons={true} />

        <Form onSubmit={handleSubmit} className="mt-4 align-items-center">
          <Row className='mb-3'>
            <Form.Group as={Col} md="4" controlId="company_id">
              <Form.Label>Organization Name</Form.Label>
              <Form.Select
                name="company_id"
                value={formData.company_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Organization</option>
                {!loadingCompany ? (<div>Loading...</div>) : (organizations.map(org => (
                  <option key={org.id} value={org.id}>{org.name}</option>
                )))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="emp_id">
              <Form.Label>Employee Name</Form.Label>
              <Form.Select
                name="emp_id"
                value={formData.emp_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Employee</option>
                {!loadingCompany ? (<div>Loading...</div>) : (employeeData.map(emp => (
                  <option key={emp.emp_id} value={emp.emp_id}>{emp.emp_name}</option>
                )))}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md='4' controlId="pay_month">
              <Form.Label>Select Month</Form.Label>
              <Form.Control
                type="month"
                name="pay_month"
                value={formData.pay_month}
                onChange={handleChange}
                required
                style={{ height: '30px' }}
              >
              </Form.Control>
            </Form.Group>
          </Row> 
          <Row className="mb-3 justify-content-center">
            <Form.Group as={Col} md='4' className="text-center">
              <Button type="submit" variant="primary" className="d-flex align-items-center mb-2" style={{ marginTop: '25px', height: '30px' }}>
                Get Payslip
              </Button>
            </Form.Group>
          </Row>
        </Form>

        {!isData ? (<div ref={printRf}>
          <Container className="p-4 border" style={{ maxWidth: '800px' }}>
            <Row className="text-center- mb-4">
              <Col>
                <h2>PaySlip </h2>
                <h4>{apiData.company}</h4>
                <p>41 Sungei Kadut Street 6 Singapore 728871</p>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={6}>
                <Table bordered size="sm">
                  <tbody>
                    <tr>
                      <td>
                        <strong>Pay Period</strong>
                      </td>
                      <td>: {apiData.pay_month}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Worked Days</strong>
                      </td>
                      <td>: {apiData.total_working_days}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col md={6}>
                <Table bordered size="sm">
                  <tbody>
                    <tr>
                      <td>
                        <strong>Employee Name </strong>
                      </td>
                      <td>: {apiData.emp_name}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Desigination </strong>
                      </td>
                      <td>: {apiData.Design}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={6}>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>
                        Earnings
                      </th>
                      <th>SGD</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Basic Pay</td>
                      <td>${apiData.basic_pay}</td>
                    </tr>
                    <tr>
                      <td>Attendance Allowance</td>
                      <td>${apiData.attendance_allowence}</td>
                    </tr>
                    <tr>
                      <td>Overtime Pay</td>
                      <td>${apiData.overtime_pay}</td>
                    </tr>
                    <tr>
                      <td>Allowence</td>
                      <td>${apiData.allowences}</td>
                    </tr>
                    <tr>
                      <td>Incentives</td>
                      <td>${apiData.incentives}</td>
                    </tr>
                    <tr className="table-active">
                      <td><strong>Total Earnings </strong></td>
                      <td><strong>${apiData.earned_gross}</strong></td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col md={6}>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>
                        Deductions
                      </th>
                      <th>SGD</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Advance</td>
                      <td>${apiData.advances}</td>
                    </tr>
                    <tr>
                      <td>Loss of Pay</td>
                      <td>${apiData.lop}</td>
                    </tr>
                    <tr>
                      <td>CPF</td>
                      <td>${apiData.CPF}</td>
                    </tr>
                    <tr>
                      <td>Other</td>
                      <td>${apiData.other}</td>
                    </tr>
                    <tr className="table-active">
                      <td><strong>Total Deductions Netpay</strong></td>
                      <td><strong>${apiData.netpay}</strong></td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col>
                <p className="text-center">
                  <strong>{apiData.netpay}</strong>
                  {/* {apiData.salaryWords} */}
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <h5>Mode of payment</h5>
                <div className="d-flex justify-content-between mb-4">
                  { paymentMode === 1 ? <span>Bank</span> : <span>Cash</span> }
                  {/* <span>Bank Deposite</span>
                  <span>Cash</span>
                  <span>Cheque</span> */}
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <div>
                    <p className="text-secondary opacity-75">~ This is System Generated Payslip ~</p>
                  </div>
                  {/* <div>
                    <p className="border-top pt-2">Employee Name</p>
                  </div> */}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        ) : (" ")}
        <div className="justify-content center">
          {!isData ? (
            <Row className="justify-content-center mt-3">
              <Col md="4" className="text-center">
                <Button className="justify-content" variant="primary" type="submit" onClick={downloadPDF}>Download</Button>
              </Col>
            </Row>
              ) : (' ')}
            </div>
      </Container>
    </div>
  )
};

export default PayslipGenerate;